var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 246,
    height: 168.5,
    viewBox: "0 0 246 168.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-423.5 -2001)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Among_survivors_with_pets_",
    "data-name": "Among survivors with pets,",
    transform: "translate(546.5 2025)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -122.26,
    y: 0
  }, "AMONG SURVIVORS WITH PETS,")), /*#__PURE__*/React.createElement("text", {
    id: "_89_",
    "data-name": "89%",
    transform: "translate(546.5 2123)",
    fill: "#fcd578",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85.55,
    y: 0
  }, "89"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "reported_partners_threatening_or_abusing_the_animal",
    "data-name": "reported partners threatening or abusing the animal",
    transform: "translate(546.5 2146.5)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -104.14,
    y: 0
  }, "reported partners threatening"), /*#__PURE__*/React.createElement("tspan", {
    x: -74.708,
    y: 20
  }, "or abusing the animal")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT2);
export default __webpack_public_path__ + "static/media/t2.0c8ff0e9b5b006ace3d4e57bcf8cb84a.svg";
export { ForwardRef as ReactComponent };